<template>
    <div class="timeDialogContent">
        <el-dialog 
            title="请进行图片验证" 
            :visible.sync="timeDialogVisible" 
            center 
            show-close 
            custom-class="timeDialog" 
            width="32%"
            :before-close="handleClose">
            <div class="mainContent">
                <el-form 
                    v-if="curTimes !== maxTimes"
                    :model="formData" 
                    :rules="rules" 
                    ref="ruleForm">
                    <el-form-item label="" prop="validCode">
                        <div class="validCodeBox">
                            <el-input 
                                autocomplete="off" size="medium" v-model.trim="formData.validCode"
                                onfocus="this.removeAttribute('readonly');" type="text" placeholder="请输入验证码"
                                maxlength="20" />
                            <img @click="getValidata" :src="ValidataUrl" />
                        </div>
                    </el-form-item>
                </el-form>
                <!-- <div class="textBox">请注意练习次数上限为{{ maxTimes }}次</div>
                <div class="textBox">成功进入后记为已模拟{{ curTimes }}次, 当前模拟次数为 {{ curTimes }}/{{ maxTimes }}</div> -->
                <div><div class="widget rich_text undefined hleft vtop " style="font-size: 14px; text-align: left; font-weight: normal; font-style: normal;"><div class="rich-text"><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:14px; color:#101010; font-style:normal; letter-spacing:0px; line-height:28px; text-decoration:none;">考生注意：输入验证码并点击确定将进入正式考试，并记录考试成绩，如未做好准备请取消退出本界面。本次考试120分钟，满分100分，考试开始后即考试计时，如中途退出界面，计时会继续，120分钟后会自动交卷。提前作答完毕，可以提前交卷</span></p></div></div></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="() => {timeDialogVisible = false}">取 消</el-button>
                <el-button 
                    size="mini" 
                    :disabled="curTimes === maxTimes"
                    :loading="btnLoading" 
                    type="primary" 
                    @click="confirm">
                    确 定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Api from '@/api/fetch.js'
import md5 from 'js-md5'
let Base64 = require('js-base64').Base64;
export default {
    name: 'ksRouleCodeDialog',
    data() {
        let isValidator = (rule, value, callback) => {
            if (md5(value) !== this.formData.code) {
                callback(new Error("请输入正确的验证码"));
            } else {
                callback();
            }
        };
        return {
            maxTimes: '',
            curTimes: '',
            timeDialogVisible: false,
            formData: {
                uuid: "8c4e6de0-b02e-4548-9c65-c790080925d0",
                code: '',
                validCode: ''
            },
            btnLoading: false,
            ValidataUrl: '',
            rules: {
                validCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    {
                        validator: isValidator,
                        trigger: "blur"
                    }
                ]
            },
        }
    },
    methods: {
        confirm() {
            this.btnLoading = true
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let userData = JSON.parse(sessionStorage.getItem('userData'))
                    Api.userReal({
                        id: userData.id,
                        provinceId: 14
                    }).then(res=>{
                        if(res.code === '0'){
                            let data = res.data
                            sessionStorage.setItem('userData', JSON.stringify({
                                ...userData,
                                examCardno: data.examCardno,
                                examPassword: data.examPassword
                            }))
                            let q = {
                                    examNumber: data.examCardno,
                                    id: userData.id,
                                    password: data.examPassword,
                                    planFlag: 1,
                                    provinceId: 14
                                }
                            this.timeDialogVisible = false
                            console.log(`${process.env.VUE_APP_KS}?q=${Base64.encode(JSON.stringify(q))}`, q);
                            window.open(`${process.env.VUE_APP_KS}?q=${Base64.encode(JSON.stringify(q))}`)
                        }else{
                            this.$message.error(res.msg)
                        }
                        this.btnLoading = false
                    })
                   
                } else {
                    console.log(`formData.code  ${this.formData.code}`, `validCode ${md5(this.formData.validCode)}`) 
                    this.btnLoading = false
                    return false
                }
            })
        },
        handleClose() {
            this.timeDialogVisible = false
        },
        openDialog(data) {
            this.timeDialogVisible = true
            this.getValidata()
            this.getTime(data)
        },
        getValidata() {
            Api.getValidata().then((res) => {
                this.ValidataUrl = res.data.imageCode;
                this.formData.uuid = res.data.uuid;
                this.formData.code = res.data.code
                this.formData.validCode = "";
            });
        },
        getTime(id) {
            Api.getTime({"id": id}).then(res => {
                if(res.code == '0') {
                    this.curTimes = res.data.curTimes
                    this.maxTimes = res.data.maxTimes
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.timeDialogContent {
    .timeDialog {
        width: 100%;
        height: 100%;

        .mainContent {
            display: flex;
            justify-content: center;
            align-content: center;
            flex-direction: column;
        }
        .textBox {
            width: 100%;
            margin-bottom: 5px;
            font-weight: 600;
            // height: 100px;
        }
    }

    .validCodeBox {
        position: relative;
        // width: 260px;

        img {
            position: absolute;
            top: 4px;
            right: 2px;
            height: 32px;
            cursor: pointer;
        }

        /deep/.el-input__inner {
            height: 32px;
            line-height: 32px;
        }
    }
}
</style>